import {ChangeEvent, useCallback, useMemo} from 'react';
import {Image} from '@shopify/hydrogen';

import VectorIcon from '../VectorIcon';
import {MemberProductScoreType} from '../../types';

import {PlaceholderWhiskyWEBP} from '../../assets/img';

import ReactModal from 'react-modal';
import {useRatingModal} from '../../contexts/RatingModalProvider.client';
import {
  RadioProductScoreField,
  ProductScoreType,
} from '../formControls/RadioProductScoreField.client';

interface RateWhiskyModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export default function RateWhiskyModal({
  isOpen,
  onRequestClose,
}: RateWhiskyModalProps) {
  const {ratingModalData, handleRatingChange} = useRatingModal();

  const productTitle = useMemo(
    () => ratingModalData?.productTitle || 'Whisky',
    [ratingModalData],
  );

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const rating = Number(e.currentTarget.value) as MemberProductScoreType;
      handleRatingChange(rating);
    },
    [handleRatingChange],
  );

  return (
    <ReactModal
      isOpen={isOpen}
      className="modal__content modal-review-inner default-modal"
      overlayClassName="modal modal_active"
      shouldCloseOnOverlayClick={true}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
    >
      <div
        className="default-modal__close close js-modal-close"
        role="button"
        tabIndex={-1}
        onClick={onRequestClose}
      >
        <VectorIcon iconName="delete-x" />
      </div>
      <div className="default-modal__box modal-review-header">
        <div className="title-2 mb-20 mt-0">Rate this whisky</div>
      </div>
      <div className="default-modal__box">
        <div className="modal-add-rating-image text-center">
          <Image
            src={ratingModalData?.productImage || PlaceholderWhiskyWEBP}
            width={250}
            height={250}
            alt={productTitle}
          />
        </div>
        <h3 className="title-2 mt-20 text-center">{productTitle}</h3>
        <RadioProductScoreField
          key="ratingOnlyModal"
          scoreType={ProductScoreType.rating}
          name="productRating"
          fieldsetClassName="add-rating-radio-ratingPopup"
          checkedValue={ratingModalData?.rating || null}
          onChange={handleChange}
        />
      </div>
    </ReactModal>
  );
}
